"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var React = _interopRequireWildcard(require("react"));
var _reactCheckboxTree = _interopRequireDefault(require("react-checkbox-tree"));
var _styledComponents = require("styled-components");
var _underscore = _interopRequireDefault(require("underscore"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CheckboxTree = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CheckboxTree, _React$Component);
  var _super = _createSuper(CheckboxTree);
  function CheckboxTree(_props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CheckboxTree);
    _this = _super.call(this, _props);
    _this.initialState = function (props) {
      _this.selectedTopNodes = [];
      var nodes = _this.fixKeys(props.nodes);
      return {
        nodes: nodes,
        checked: _this.initialChecked(nodes),
        expanded: _this.initialExpanded(nodes)
      };
    };
    _this.updateExpand = function (expanded) {
      _this.setState({
        expanded: expanded
      });
    };
    _this.isNodeChecked = function (node) {
      return _this.props.checked.indexOf(_this.originalValueMap[node.value]) >= 0;
    };
    _this.onCheck = function (checked) {
      _this.setState({
        checked: checked
      });
      if (_this.props.onChange) {
        _this.selectedTopNodes = [];
        var topLayerChecked = _this.nodesFullySelected(_this.state.nodes, checked).concat(_this.selectedTopNodes);
        var topLayerIds = topLayerChecked.map(function (node) {
          return _this.originalValueMap[node.value];
        });
        var checkedLeafIds = _this.leafNodesSelected(_this.state.nodes, checked).map(function (node) {
          return _this.originalValueMap[node.value];
        });
        _this.props.onChange(topLayerIds, checked.map(function (v) {
          return _this.originalValueMap[v];
        }), checkedLeafIds);
      }
    };
    _this.originalValueMap = {}; // Utilized to maintain node value type for `onChange`
    _this.state = _this.initialState(_props);
    return _this;
  }
  (0, _createClass2["default"])(CheckboxTree, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (JSON.stringify(nextProps.nodes) !== JSON.stringify(this.props.nodes)) {
        this.setState(this.initialState(nextProps));
      }
    }
  }, {
    key: "initialChecked",
    value:
    /*
      1. Return every value if checkAll is true
      2. Return checked value passed in props and all it's children
      3. Return empty array if default to nothing
     */
    function initialChecked(nodes) {
      if (this.props.checkAll) {
        return this.getAllValues(nodes);
      } else if (this.props.checked.length > 0) {
        var checkedChildrenIds = this.getAllValues(this.nodesToCheck(nodes));
        var allCheckedNodeIds = this.props.checked.concat(checkedChildrenIds);
        return allCheckedNodeIds.filter(function (node, pos, self) {
          return self.indexOf(node) === pos;
        }); // Filter unique
      } else {
        return [];
      }
    }

    /*
      If passing in a parent node that is checked, this will ensure all children nodes are checked
     */
  }, {
    key: "nodesToCheck",
    value: function nodesToCheck(nodes) {
      var checkedNodes = nodes.filter(this.isNodeChecked);
      var children = this.childNodes(nodes);
      var childrenNodesToCheck = [];
      if (children.length > 0) {
        childrenNodesToCheck = this.nodesToCheck(children);
      }
      return checkedNodes.concat(childrenNodesToCheck);
    }

    /*
      Expand nodes where the parent is not checked but the children are
     */
  }, {
    key: "initialExpanded",
    value: function initialExpanded(nodes) {
      if (this.props.expandAll) {
        return this.getAllValues(nodes);
      } else {
        var nodesToExpand = this.nodesToExpand(nodes),
          nodesToExpandId = nodesToExpand.map(function (node) {
            return node.value;
          });
        return this.props.expanded.concat(nodesToExpandId);
      }
    }
  }, {
    key: "nodesToExpand",
    value: function nodesToExpand(nodes) {
      var _this2 = this;
      var nodeWithCheckedChildren = nodes.filter(function (node) {
        if (node.children) {
          return node.children.filter(function (child) {
            return _this2.props.checked.indexOf(child.value) >= 0;
          }).length > 0;
        } else {
          return false;
        }
      });
      var children = this.childNodes(nodes);
      var childrenNodesToExpand = [];
      if (children.length > 0) {
        childrenNodesToExpand = this.nodesToExpand(children);
      }
      return nodeWithCheckedChildren.concat(childrenNodesToExpand);
    }

    /*
      Get every value in this tree. Used for checkAll
     */
  }, {
    key: "getAllValues",
    value: function getAllValues(nodes) {
      if (nodes.length > 0) {
        var nodesValue = nodes.map(function (node) {
          return node.value;
        });
        return nodesValue.concat(this.getAllValues(this.childNodes(nodes)));
      } else {
        return [];
      }
    }
  }, {
    key: "childNodes",
    value: function childNodes(nodes) {
      var _ref;
      var children = nodes.map(function (node) {
        return node.children;
      });
      return (_ref = []).concat.apply(_ref, (0, _toConsumableArray2["default"])(children)).filter(function (node) {
        return node !== undefined;
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement(_reactCheckboxTree["default"], {
        nodes: this.state.nodes,
        checked: this.state.checked,
        expanded: this.state.expanded,
        showNodeIcon: false,
        onCheck: this.onCheck,
        onExpand: this.updateExpand
      }));
    }
  }, {
    key: "fixKeys",
    value: function fixKeys(nodes) {
      var _this3 = this;
      var mapValues = function mapValues(node) {
        if (node.hasOwnProperty('text') || node.hasOwnProperty('name') || node.hasOwnProperty('id') || node.hasOwnProperty('value')) {
          var valueString = (node.value || node.id).toString();
          if (!_this3.originalValueMap[valueString]) {
            _this3.originalValueMap[valueString] = (node.value || node.id).valueOf();
          }
          var returnValue = {
            value: valueString,
            label: node.label || node.text || node.name
          };
          if (Array.isArray(node.children)) {
            returnValue.children = node.children.map(mapValues);
          }
          return returnValue;
        }
      };
      return nodes.map(mapValues);
    }

    /*
      The state only stores the checked leaf nodes. We usually want only the highest most parent node that's checked
      So this will return the top most fully selected node
     */
  }, {
    key: "nodesFullySelected",
    value: function nodesFullySelected(nodes, checked) {
      var _this4 = this;
      return nodes.filter(function (node) {
        if (node.children) {
          var goodNodes = _this4.nodesFullySelected(node.children, checked);
          if (goodNodes.length === node.children.length) {
            return true;
          } else {
            _this4.selectedTopNodes = _this4.selectedTopNodes.concat(goodNodes);
            return false;
          }
        } else {
          return checked.indexOf(node.value.toString()) >= 0;
        }
      });
    }
  }, {
    key: "leafNodes",
    value: function leafNodes(nodes) {
      var _this5 = this;
      return _underscore["default"].flatten(nodes.map(function (node) {
        if (node.children) {
          return _this5.leafNodes(node.children);
        } else {
          return [node];
        }
      }));
    }
  }, {
    key: "leafNodesSelected",
    value: function leafNodesSelected(nodes, checked) {
      var leaves = this.leafNodes(nodes);
      return leaves.filter(function (leaf) {
        return checked.indexOf(leaf.value) >= 0;
      });
    }
  }]);
  return CheckboxTree;
}(React.Component);
exports["default"] = CheckboxTree;
CheckboxTree.defaultProps = {
  nodes: [],
  checked: [],
  expanded: [],
  checkAll: false,
  expandAll: false
};
var GlobalStyle = (0, _styledComponents.createGlobalStyle)([".react-checkbox-tree{font-size:14px;.rct-title{padding:3px 0;display:table-cell;word-break:break-word;}.rct-text{font-weight:400;}.rct-text label{display:table;}input[type=\"checkbox\"]{margin-right:5px;}button{outline:0;border:0;background-color:transparent;float:left;margin-top:6px;margin-left:2px;.rct-icon{display:inline-block;width:0;height:0;border-style:solid;border-width:4px 0 4px 6.9px;border-color:transparent transparent transparent black;&.rct-icon-expand-open{transform:rotate(90deg);-webkit-transform:rotate(90deg);}}}.rct-node{&.rct-node-parent{margin-left:0;padding-left:0;}&.rct-node-leaf{margin-left:0px;}.rct-node{&.rct-node-parent{margin-left:20px}&.rct-node-leaf{margin-left:35px}}}ol{list-style-type:none;padding-left:0;}li{padding:0 5px;}}"]);